export enum ResetScreen {
  VERIFYING = 'verifying',
  EXPIRED = 'expired',
  FAILED = 'failed',
  FORM = 'form',
}

export const LINK_ERROR_MESSAGE = 'This link has expired or is invalid. Please request a new one.';
